
import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CardPrestataireV2 from "../CardPrestataireV2";
import "./sharedPrestataire.css";
export default function SharedPrestataire() {
    const { id } = useParams();
    const navigate = useNavigate();

    const apiUrl = process.env.REACT_APP_API_URL;

    const [loading, setLoading] = useState(false);
    const [prestataire, setPrestataire] = useState(null);

    const refreshPrestataire = useCallback(() => {
        setLoading(true);

        const params = new URLSearchParams();
        params.append("idPrestataire", id);

        const url = `${apiUrl}/api/presta?${params.toString()}`;

        fetch(url)
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Impossible de récupérer le prestataire");
                }
                return res.json();
            })
            .then((data) => {
                setPrestataire(data.prestataire);
            })
            .catch((err) => console.error(err))
            .finally(() => setLoading(false));
    }, [apiUrl, id]);

    useEffect(() => {
        refreshPrestataire();
    }, [refreshPrestataire]);

    return (
        <section className="section-list-presta">
            <h2 className="gold-text">INTERESEAUX</h2>

            <h3
                style={{
                    textAlign: "center",
                    fontSize: "1.6em",
                }}
            >
                Ce prestataire devrait vous intéresser
            </h3>

            <div className="list-presta-container">
                {loading && <p>Chargement du prestataire...</p>}

                {!loading && prestataire && (
                    <CardPrestataireV2 prestataire={prestataire} />
                )}

                {!loading && !prestataire && (
                    <p>Ce prestataire est introuvable.</p>
                )}
            </div>

            {/* Bouton pour découvrir les autres prestataires */}
            <div className="shared-presta-actions">
                <button
                    type="button"
                    className="voir-autres-prestataires-button"
                    onClick={() => navigate("/")}
                >
                    Voir les autres prestataires
                </button>
            </div>
        </section>
    );
}
